/* eslint-disable @typescript-eslint/no-explicit-any */
import { addMethod, AnyObject, mixed, MixedSchema, object, ObjectSchema, string, StringSchema } from 'yup';

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

function phone(this: StringSchema, message: string) {
  return this.test({
    message: message,
    name: 'phone',
    test: (value) => (value && value !== '' ? phoneRegExp.test(value) : false),
  });
}

function notEmptyString(this: MixedSchema, message: string) {
  return this.test({
    message: message,
    name: 'notEmptyString',
    test: (value) => (typeof value === 'string' && value.trim() === '' ? false : true),
  });
}

function anyChild(value: unknown) {
  if (!value) return false;

  const hasChild = Object.values(value).some(child => {
    if (child === null) return false;
    if (child === undefined) return false
    if (typeof child === 'string' && child.trim() === '') return false
    if (typeof child === 'number' && isNaN(child)) return false
    if (child instanceof Date && isNaN(child as any)) return false
    if (!(child instanceof Date) && typeof child === 'object' && !anyChild(child)) return false
    return true;
  });

  return hasChild;
}

function makeOptional(this: ObjectSchema<AnyObject>, isOptional = true, defaultValue = undefined) {
  return this.transform(function (value) {
    // If false is passed, skip the transform
    if (!isOptional) return value;

    // If any child property has a value, skip the transform (abort e.g. is not optional anymore)
    if (anyChild(value)) {
      return value;
    }
    return defaultValue;
    // adding .default() will make sure that the object will always be the passed defaultValue without having to set it on each places where this is used
    // unfortunatly this breaks typing here so we have to pass any
  }).default(defaultValue) as any;
}

export const addYupMethods = () => {
  addMethod(string, 'phone', phone);
  // 2022-10-26: when using required only `string` schema will check for empty string - for mixed we need to have a custom check for empty string
  // see here: https://github.com/jquense/yup#schemarequiredmessage-string--function-schema
  addMethod(mixed, 'notEmptyString', notEmptyString);

  // a method that allows to use an object as optional although it has required properties within it (only works if the default is undefined for that object)
  // see here: https://objectpartners.com/2020/06/04/validating-optional-objects-with-yup/
  addMethod(object, 'makeOptional', makeOptional)
};

// self call otherwise it wont be initialized before bundler is going to load it
addYupMethods();
